import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Grid2 from "@mui/material/Unstable_Grid2";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  inputClasses,
  inputLabelClasses,
} from "@mui/material";
import Home from "../home/Home";
import FundRqst_service from "../../Services/FundRqst_service";
import Snackbar from "../Snacbar";
import { getUserId } from "../Utils/Common";
import FileSaver from "file-saver";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useNavigate } from "react-router";
import { ToggleButton } from "@mui/material";
import { Col, Row } from "react-bootstrap";

const CssTextField = styled(TextField)(`
  .${inputClasses.root} {
    height:35px;
  }
  .${inputLabelClasses.root} {
    font-family: Times New Roman;
    font-weight:bold;
    &.${inputLabelClasses.focused} {
      color: primary;
    }
  }
`);
const Csscontrol = styled(FormControl)({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {},
  },
});
const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(0.5),
  textAlign: "center",
  color: theme.palette.text.secondary,
  backgroundColor: "white",
  height: "100%",
  border: "1px solid black",
}));
const Item1 = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(0.5),
  // textAlign: 'center',
  color: theme.palette.text.secondary,
  backgroundColor: "white",
  height: "100%",
  border: "1px solid black",
}));
const Item2 = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(0.5),
  textAlign: "right",
  color: theme.palette.text.secondary,
  backgroundColor: "white",
  height: "100%",
  border: "1px solid black",
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: theme.palette.common.black,
    backgroundColor: "rgb(61, 195, 177)",
    padding: theme.spacing(0.5),
    fontFamily: "Times New Roman",
    fontWeight: "bold",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: "Times New Roman",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {},
}));

function FundRequest() {
  const [fundRqstdetails, setfundRqstdetails] = useState([]);
  const [fundRqstdetails2, setfundRqstdetails2] = useState([]);
  const [fundRqstdetails3, setfundRqstdetails3] = useState([]);
  const [fundRqstdetails4, setfundRqstdetails4] = useState([]);
  const [fundRqstdetails5, setfundRqstdetails5] = useState([]);
  //
  const [FilteredDetails, setFilteredDetails] = useState([]);
  const [FilteredDetails2, setFilteredDetails2] = useState([]);

  // const [paymentcopydetails, setpaymentcopydetails] = useState([])

  const [imgUpload, setimgUpload] = useState(false);

  const [rqstbtn, setrqstbtn] = useState(true);
  const [updatebtn, setupdatebtn] = useState(true);
  const [nonReqbtn, setnonReqbtn] = useState(true);
  const [uploadrqstcopybtn, setuploadrqstcopybtn] = useState(true);
  const [downloadrqstcopy, setdownloadrqstcopy] = useState(true);
  const [finish, setfinish] = useState(true);
  const [searchbtnhidden, setsearchbtnhidden] = useState(true);

  const [reqstPros, setreqstPros] = useState(false);
  const [updtPros, setupdtPros] = useState(false);
  const [nonRqstPros, setnonRqstPros] = useState(false);
  const [RefreshPros, setRefreshPros] = useState(false);
  const [uplodaRqstCopyPros, setuplodaRqstCopyPros] = useState(false);
  const [dwnldReqCopyPros, setdwnldReqCopyPros] = useState(false);
  const [finishPros, setfinishPros] = useState(false);
  const [searchPros, setsearchPros] = useState(false);

  const [message, setMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [severit, setseverit] = useState("");

  const [status, setstatus] = useState("");

  const [fundstatusdrp, setfundstatusdrp] = useState([]);
  const [vendordrp, setvendordrp] = useState([]);
  const [purposePaymentdrp, setpurposePaymentdrp] = useState([]);
  const [paidtypedrp, setpaidtypedrp] = useState([]);
  const [paidtodrp, setpaidtodrp] = useState([]);
  const [Paymentmode, setPaymentmode] = useState([]);
  // BE NO specific states
  // BE NO specific states
  const [BeNoHidden, setBeNoHidden] = useState(true);
  const [BeNoSearchHidden, setBeNoSearchHidden] = useState(true);
  const [beNoValue, setBeNoValue] = useState("");

  const [FundRqstvalues, setFundRqstvalues] = useState({
    cmid: "",
    purpose_pmtid: "",
    purpose_reqpurid: "",
    purposeSummary_id: "",

    fundstatus: "",
    jobNo: "",
    vendorType: "",
    RequestAmt: "",
    purposeOfpayment: "",
    paidtype: "",
    paidto: "",
    paymntMode: "",
    fundrefundstatus: "",
    RequestRmks: "",
  });

  ///Handle Change=>>
  const FundRqstStatusHandleChange = (e) => {
    const value = e.target.value;

    // Reset form fields and details
    setFundRqstvalues({
      ...FundRqstvalues,
      fundstatus: value,
      cmid: "",
      purpose_pmtid: "",
      purpose_reqpurid: "",
      purposeSummary_id: "",
      RequestAmt: "",
      purposeOfpayment: "",
      paidtype: "",
      paidto: "",
      paymntMode: "",
      fundrefundstatus: "",
      RequestRmks: "",
      jobNo: "",
      vendorType: "",
    });

    // Reset lists
    setFilteredDetails([]);
    setFilteredDetails2([]);
    setfundRqstdetails([]);
    setfundRqstdetails2([]);
    setfundRqstdetails3([]);
    setfundRqstdetails4([]);
    setfundRqstdetails5([]);

    // Hide everything first
    SetVendorHidden(true);
    SetJobHidden(true);
    setdesignHidden(true);
    settablehidden(true);
    setpaidtypehidden(true);
    setpaidbyhidden(true);
    setsearchbtnhidden(true);
    setBeNoHidden(true);
    setBeNoSearchHidden(true);

    // ⚙️ Special case: BE NO
    if (value === "BE NO") {
      setstatus(5);
      setBeNoHidden(false);
      setBeNoSearchHidden(false);
      setBeNoValue("");
      return;
    }

    // Normal flow for JOB / VENDOR / CLIENT / MISC
    if (value === "JOB") {
      setstatus(1);
    } else if (value === "VENDOR") {
      setstatus(2);
    } else if (value === "MISCELLANEOUS") {
      setstatus(3);
    } else if (value === "CLIENT") {
      setstatus(4);
    }

    let consignmentNumber = "-1";
    if (value === "JOB") {
      consignmentNumber = FundRqstvalues.jobNo || "-1";
    } else {
      consignmentNumber = FundRqstvalues.vendorType || "-1";
    }

    const details = { consignmentNumber, status: "1", requestStatus: value };
    FundRqst_service.getPaymentNonJobNo(details).then((res) => {
      setfundRqstdetails(res.data || []);
      setFilteredDetails(res.data || []);
    });

    FundRqst_service.getPaymentJobNo(details).then((res) => {
      setfundRqstdetails4(res.data || []);
      setFilteredDetails2(res.data || []);
    });

    purposePaymentModeDropdown();

    if (value === "JOB") {
      paidTypeDropdown();
      SetVendorHidden(true);
      SetJobHidden(false);
      setdesignHidden(false);
      settablehidden(false);
      setpaidbyhidden(false);
      setpaidtypehidden(false);
      setsearchbtnhidden(false);
    } else if (["VENDOR", "MISCELLANEOUS", "CLIENT"].includes(value)) {
      FundRqst_service.getVendorType(value).then((res) =>
        setvendordrp(res.data || [])
      );
      SetVendorHidden(false);
      SetJobHidden(true);
      setdesignHidden(false);
      settablehidden(false);
      setpaidtypehidden(true);
      setpaidbyhidden(true);
      setsearchbtnhidden(true);
    } else if (value === "") {
      SetVendorHidden(true);
      SetJobHidden(true);
      setdesignHidden(true);
      settablehidden(true);
      setsearchbtnhidden(true);
    }
  };

  const handleBeNoSearch = async () => {
    const beNo = beNoValue && beNoValue.trim();
    if (!beNo) {
      setMessage("Please enter BE No before searching!");
      setseverit("warning");
      setOpen(true);
      return;
    }

    setsearchPros(true);

    try {
      // 1️⃣ Call BE NO APIs to get consignment numbers
      const beNoPayload = {
        consignmentNumber: beNo,
        status: "1",
        requestStatus: "BE NO",
      };

      const [beNonJobRes, beJobRes] = await Promise.all([
        FundRqst_service.getPaymentNonJobNo(beNoPayload),
        FundRqst_service.getPaymentJobNo(beNoPayload),
      ]);

      // 2️⃣ Merge both responses
      const beNoData = [
        ...(beNonJobRes?.data || []),
        ...(beJobRes?.data || []),
      ];

      const consignmentNumbers = [
        ...new Set(
          beNoData.map((item) => item.consignmentNumber).filter(Boolean)
        ),
      ];

      if (consignmentNumbers.length === 0) {
        setMessage("No consignment numbers found for this BE No!");
        setseverit("info");
        setOpen(true);
        setsearchPros(false);
        return;
      }

      // 3️⃣ Fetch job-related data for each consignment
      const jobRequests = consignmentNumbers.map((cno) => {
        const jobPayload = {
          consignmentNumber: cno,
          status: "1",
          requestStatus: "JOB",
        };
        return Promise.all([
          FundRqst_service.getPaymentNonJobNo(jobPayload),
          FundRqst_service.getPaymentJobNo(jobPayload),
        ]);
      });

      const jobResponses = await Promise.all(jobRequests);

      // 4️⃣ Merge all job responses
      const allNonJobData = [];
      const allJobData = [];

      jobResponses.forEach(([nonJobRes, jobRes]) => {
        if (nonJobRes?.data) allNonJobData.push(...nonJobRes.data);
        if (jobRes?.data) allJobData.push(...jobRes.data);
      });

      // 5️⃣ Update your tables
      setfundRqstdetails(allNonJobData);
      setFilteredDetails(allNonJobData);
      setfundRqstdetails4(allJobData);
      setFilteredDetails2(allJobData);

      // ✅ Switch UI from BE NO to JOB mode
      setBeNoHidden(true);
      setBeNoSearchHidden(true);
      SetVendorHidden(true);
      SetJobHidden(false);
      setdesignHidden(false);
      settablehidden(false);
      setpaidbyhidden(false);
      setpaidtypehidden(false);
      setsearchbtnhidden(false);

      // ✅ Change Fund Status dropdown value to "JOB"
      setFundRqstvalues((prev) => ({
        ...prev,
        fundstatus: "JOB",
      }));

      // Optional: Feedback message for clarity
      setMessage("BE No search completed — switched to JOB mode");
      setseverit("success");
      setOpen(true);
    } catch (err) {
      setMessage(err.message || "Error fetching BE NO details");
      setseverit("error");
      setOpen(true);
    } finally {
      setsearchPros(false);
    }
  };

  const Request_jobNoHandleChange = (e) => {
    setFundRqstvalues({ ...FundRqstvalues, jobNo: e.target.value });
  };
  const Request_vendortypHandleChange = (e) => {
    setFundRqstvalues({ ...FundRqstvalues, vendorType: e.target.value });
    let details = {
      consignmentNumber: e.target.value,
      status: "1",
      requestStatus: FundRqstvalues.fundstatus,
    };
    FundRqst_service.getPaymentNonJobNo(details).then((res) => {
      setfundRqstdetails(res.data);
      setFilteredDetails(res.data);
    });

    let details2 = {
      consignmentNumber: e.target.value,
      status: "1",
      requestStatus: FundRqstvalues.fundstatus,
    };
    FundRqst_service.getPaymentJobNo(details2).then((res) => {
      setfundRqstdetails4(res.data);
      setFilteredDetails2(res.data);
    });
  };
  const Request_amtHandleChange = (e) => {
    setFundRqstvalues({ ...FundRqstvalues, RequestAmt: e.target.value });
  };
  const Request_purposeHandleChange = (e) => {
    setFundRqstvalues({ ...FundRqstvalues, purposeOfpayment: e.target.value });
  };
  const Request_paidtypeHandleChange = (e) => {
    setFundRqstvalues({ ...FundRqstvalues, paidtype: e.target.value });
    let details = {
      consignmentNumber: e.target.value,
      status: "1",
      requestStatus: "-1",
    };
    FundRqst_service.getPaymentNonJobNo(details).then((res) => {
      setpaidtodrp(res.data);
    });
  };
  const Request_paidtoHandleChange = (e) => {
    setFundRqstvalues({ ...FundRqstvalues, paidto: e.target.value });
  };
  const Request_paymntmdHandleChange = (e) => {
    setFundRqstvalues({ ...FundRqstvalues, paymntMode: e.target.value });
  };
  const Request_fundrefundstatusHandleChange = (e) => {
    setFundRqstvalues({ ...FundRqstvalues, fundrefundstatus: e.target.value });
  };
  const Request_RmksHandleChange = (e) => {
    setFundRqstvalues({ ...FundRqstvalues, RequestRmks: e.target.value });
  };
  ///hidden
  const [designHidden, setdesignHidden] = useState(true);
  const [tablehidden, settablehidden] = useState(true);
  const [VendorHidden, SetVendorHidden] = useState(true);
  const [JobHidden, SetJobHidden] = useState(false);
  const [paidtypehidden, setpaidtypehidden] = useState(true);
  const [paidbyhidden, setpaidbyhidden] = useState(true);
  ///
  const FundStsName = () => {
    if (status === 1) {
      return "Job No";
    } else if (status === 2) {
      return "VENDOR";
    } else if (status === 3) {
      return "MISCELLANEOUS";
    } else if (status === 4) {
      return "CLIENT";
    }
  };
  ///keydown
  const jobKeydown = (e) => {
    if (e.key === "Enter") {
      setrqstbtn(true);
      setupdatebtn(true);
      setnonReqbtn(true);
      setuploadrqstcopybtn(true);
      setdownloadrqstcopy(true);
      setFundRqstvalues({
        ...FundRqstvalues,
        cmid: "",
        purpose_pmtid: "",
        purpose_reqpurid: "",
        RequestAmt: "",
        purposeOfpayment: "",
        paidtype: "",
        paidto: "",
        paymntMode: "",
        fundrefundstatus: "",
        RequestRmks: "",
      });
      setfundRqstdetails2([]);
      setfundRqstdetails3([]);
      Getpaymentjob_nonjob_no();
    }
  };
  const RequestAMtKeydown = (e) => {
    if (e.key === "Enter") {
      document.getElementById("purposepaymnt").focus();
    }
  };
  const purposeKeydown = (e) => {
    if (e.key === "Enter") {
      if (paidtypehidden === false) {
        document.getElementById("paidtype").focus();
      } else {
        document.getElementById("paymentmode").focus();
      }
    }
  };
  const paidtypeKeydown = (e) => {
    if (e.key === "Enter") {
      document.getElementById("paidto").focus();
    }
  };
  const paidtoKeydown = (e) => {
    if (e.key === "Enter") {
      document.getElementById("paymentmode").focus();
    }
  };
  const paymentModeKeydown = (e) => {
    if (e.key === "Enter") {
      document.getElementById("fundrefund").focus();
    }
  };
  const refundStatusKeydown = (e) => {
    if (e.key === "Enter") {
      document.getElementById("remarksid").focus();
    }
  };
  // validate=====>
  const Requestvalidate = () => {
    if (FundRqstvalues.RequestAmt !== "") {
      if (FundRqstvalues.purposeOfpayment !== "") {
        if (FundRqstvalues.paymntMode !== "") {
          return true;
        } else {
          setMessage("Please Select Payment Mode ..!!");
          setseverit("warning");
          setOpen(true);
          document.getElementById("paymentmode").focus();
        }
        return true;
      } else {
        setMessage("Please Select Purpose Of Payment ..Warning ..!!");
        setseverit("warning");
        setOpen(true);
        document.getElementById("purposepaymnt").focus();
      }
    } else {
      setMessage("Please Enter Payment Request Amount ..Warning ..!!");
      setseverit("warning");
      setOpen(true);
      document.getElementById("rqstamnt").focus();
    }
    return false;
  };
  ///all rest......===================>
  const BtnsReset = () => {
    setrqstbtn(true);
    setupdatebtn(true);
    setnonReqbtn(true);
    setuploadrqstcopybtn(true);
    setdownloadrqstcopy(true);
  };
  const resetalloperation = () => {
    setFundRqstvalues({
      ...FundRqstvalues,
      cmid: "",
      purpose_pmtid: "",
      purpose_reqpurid: "",
      purposeSummary_id: "",
      RequestAmt: "",
      purposeOfpayment: "",
      paidtype: "",
      paidto: "",
      paymntMode: "",
      fundrefundstatus: "",
      RequestRmks: "",
      jobNo: "",
    });
    setFilteredDetails([]);
    setFilteredDetails2([]);
    setfundRqstdetails([]);
    setfundRqstdetails2([]);
    setfundRqstdetails3([]);
    setfundRqstdetails4([]);
    setfundRqstdetails5([]);
    setreqstPros(false);
    setupdtPros(false);
    setnonRqstPros(false);
    setRefreshPros(false);
    setuplodaRqstCopyPros(false);
    setdwnldReqCopyPros(false);
    setfinishPros(false);
    BtnsReset();
    Getpaymentjob_nonjob_no();
  };

  const RefreshBtn = () => {
    setFundRqstvalues({
      ...FundRqstvalues,
      cmid: "",
      purpose_pmtid: "",
      purpose_reqpurid: "",
      fundstatus: "JOB",
      jobNo: "",
      vendorType: "",
      purposeOfpayment: "",
      paidtype: "",
      paidto: "",
      paymntMode: "",
      fundrefundstatus: "",
      RequestRmks: "",
      RequestAmt: "",
    });
    setFilteredDetails([]);
    setFilteredDetails2([]);
    setfundRqstdetails([]);
    setfundRqstdetails2([]);
    setfundRqstdetails3([]);
    setfundRqstdetails4([]);
    setfundRqstdetails5([]);
    BtnsReset();
    Getpaymentjob_nonjob_no();
    document.getElementById("fundstatus").focus();
    setreqstPros(false);
    setRefreshPros(false);
    setupdtPros(false);
    setnonRqstPros(false);
    setuplodaRqstCopyPros(false);
    setdwnldReqCopyPros(false);
    setfinishPros(false);
  };
  //////
  const Jobserachbtn = () => {
    setsearchPros(true);
    setrqstbtn(true);
    setupdatebtn(true);
    setnonReqbtn(true);
    setuploadrqstcopybtn(true);
    setdownloadrqstcopy(true);
    setFundRqstvalues({
      ...FundRqstvalues,
      cmid: "",
      purpose_pmtid: "",
      purpose_reqpurid: "",
      RequestAmt: "",
      purposeOfpayment: "",
      paidtype: "",
      paidto: "",
      paymntMode: "",
      fundrefundstatus: "",
      RequestRmks: "",
    });
    setfundRqstdetails2([]);
    setfundRqstdetails3([]);
    Getpaymentjob_nonjob_no();
  };
  const [selected, setSelected] = useState([]);
  const [selected1, setSelected1] = useState([]);

  const getnonpurpose = (trns) => {
    setfundRqstdetails5([]);
    const selectedIndex = selected.indexOf(trns.consignmentNumber);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = (selected, trns.consignmentNumber);
    }
    setSelected(newSelected);
    setrqstbtn(false);
    setupdatebtn(true);
    setnonReqbtn(true);
    setuploadrqstcopybtn(true);
    setfinish(false);
    setdownloadrqstcopy(true);
    setFundRqstvalues({
      ...FundRqstvalues,
      cmid: trns.cmId,
      purpose_pmtid: "",
      purpose_reqpurid: "",
      purposeSummary_id: "",
      non_jobid: "",
      RequestAmt: "",
      purposeOfpayment: "",
      paidtype: "",
      paidto: "",
      paymntMode: "",
      fundrefundstatus: "",
      RequestRmks: "",
    });
    setfundRqstdetails3([]);
    let details = {
      cmId: trns.cmId,
      status: "1",
      requestStatus: FundRqstvalues.fundstatus,
    };
    FundRqst_service.getPaymentReqPurpose(details).then((res) => {
      setfundRqstdetails2(res.data);
    });

    let details2 = {
      paymentId: trns.cmId,
      requestStatus: FundRqstvalues.fundstatus,
    };
    FundRqst_service.getPaymentSummaryDetails(details2).then((res) => {
      setfundRqstdetails5(res.data);
    });
  };
  const isSelected = (name) => selected.indexOf(name) !== -1;
  ///
  const nonverifypurpose = (trns) => {
    setfundRqstdetails3([]);
    setrqstbtn(false);
    setupdatebtn(false);
    setnonReqbtn(true);
    setuploadrqstcopybtn(true);
    setdownloadrqstcopy(true);

    getpaymentdetailsAssign(trns.paymentId, trns.reqPurpose, 1);
  };
  const verifypurpose = (trns) => {
    const selectedInd = selected1.indexOf(trns.reqAmount);
    let newSelect = [];

    if (selectedInd === -1) {
      newSelect = (selected1, trns.reqAmount);
    }
    setSelected1(newSelect);

    setfundRqstdetails2([]);
    setrqstbtn(true);
    setupdatebtn(false);
    setnonReqbtn(false);
    setuploadrqstcopybtn(false);
    setdownloadrqstcopy(false);
    setfinish(true);

    getpaymentdetailsAssign(trns.paymentId, trns.reqPurpose, 2);
  };
  const isReqpurposeSelected = (name) => selected1.indexOf(name) !== -1;
  ///
  const getpurpose = (trns) => {
    setfundRqstdetails5([]);
    setfundRqstdetails3([]);
    const selectedIndex = selected.indexOf(trns.consignmentNumber);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = (selected, trns.consignmentNumber);
    }
    setSelected(newSelected);

    setrqstbtn(true);
    setupdatebtn(false);
    setnonReqbtn(false);
    // setuploadrqstcopybtn(false)
    setdownloadrqstcopy(false);
    setfinish(true);
    setFundRqstvalues({
      ...FundRqstvalues,
      cmid: trns.cmId,
      purpose_pmtid: "",
      purpose_reqpurid: "",
      purposeSummary_id: "",
      non_jobid: "",
      RequestAmt: "",
      purposeOfpayment: "",
      paidtype: "",
      paidto: "",
      paymntMode: "",
      fundrefundstatus: "",
      RequestRmks: "",
    });
    setfundRqstdetails2([]);

    let details = {
      cmId: trns.cmId,
      status: "10",
      requestStatus: FundRqstvalues.fundstatus,
    };
    FundRqst_service.getPaymentReqPurpose(details).then((res) => {
      setfundRqstdetails3(res.data);
    });

    let details2 = {
      paymentId: trns.cmId,
      requestStatus: FundRqstvalues.fundstatus,
    };
    FundRqst_service.getPaymentSummaryDetails(details2).then((res) => {
      setfundRqstdetails5(res.data);
    });
  };
  const isReqjobSelected = (name) => selected.indexOf(name) !== -1;
  ////
  const getpaymentdetailsAssign = (payid, reqid) => {
    let details = { paymentId: payid };
    FundRqst_service.getPaymentDetails(details)
      .then((res) => {
        const data = res.data;
        console.log("assign values==>" + JSON.stringify(data));
        const details = data.map((trns) => trns);
        setFundRqstvalues({
          ...FundRqstvalues,
          RequestAmt: details[0].reqAmount,
          purposeOfpayment: details[0].reqPurpose,
          paidto: details[0].reqPaidTo,
          RequestRmks: details[0].reqRemarks,
          paymntMode: details[0].reqMode,
          fundrefundstatus: details[0].refundStatus,
          paidtype: details[0].paymentId,
          purpose_pmtid: payid,
          purpose_reqpurid: reqid,
        });
      })
      .catch((error) => {
        setMessage(error.message);
        setseverit("error");
        setOpen(true);
      });
  };
  /////
  const Getpaymentjob_nonjob_no = () => {
    var consignmentNumber = "";
    if (FundRqstvalues.fundstatus === "JOB") {
      if (FundRqstvalues.jobNo === "") {
        consignmentNumber = "-1";
      } else {
        consignmentNumber = FundRqstvalues.jobNo;
      }
    } else if (FundRqstvalues.fundstatus !== "JOB") {
      if (FundRqstvalues.vendorType === "") {
        consignmentNumber = "-1";
      } else {
        consignmentNumber = FundRqstvalues.vendorType;
      }
    }
    let details = {
      consignmentNumber: consignmentNumber,
      status: "1",
      requestStatus: FundRqstvalues.fundstatus,
    };
    FundRqst_service.getPaymentNonJobNo(details).then((res) => {
      setfundRqstdetails(res.data);
      setFilteredDetails(res.data);
    });

    let details2 = {
      consignmentNumber: consignmentNumber,
      status: "1",
      requestStatus: FundRqstvalues.fundstatus,
    };
    FundRqst_service.getPaymentJobNo(details2).then((res) => {
      setfundRqstdetails4(res.data);
      setFilteredDetails2(res.data);
    });
    setsearchPros(false);
  };

  const purposePaymentModeDropdown = () => {
    FundRqst_service.getRequestPurpose().then((res) => {
      setpurposePaymentdrp(res.data);
    });

    FundRqst_service.getBillPaymentType().then((res) => {
      setPaymentmode(res.data);
    });
  };
  const paidTypeDropdown = () => {
    FundRqst_service.getVendorType("JOB").then((res) => {
      setpaidtypedrp(res.data);
    });
  };
  ////button click=====>
  const RequestonClick = () => {
    if (Requestvalidate() === true) {
      setreqstPros(true);
      var ReqPaidto,
        refundStatus = "";
      if (FundRqstvalues.fundstatus === "JOB") {
        if (FundRqstvalues.paidto !== "") {
          ReqPaidto = FundRqstvalues.paidto;
        } else {
          ReqPaidto = null;
        }
      } else {
        if (FundRqstvalues.vendorType !== "") {
          ReqPaidto = FundRqstvalues.vendorType;
        } else {
          ReqPaidto = null;
        }
      }
      if (FundRqstvalues.fundrefundstatus !== "") {
        refundStatus = FundRqstvalues.fundrefundstatus;
      } else {
        refundStatus = null;
      }
      let details = {
        cmId: FundRqstvalues.cmid,
        reqAmount: FundRqstvalues.RequestAmt,
        reqPurpose: FundRqstvalues.purposeOfpayment,
        reqPaidTo: ReqPaidto,
        reqDate: "null",
        reqBy: getUserId(),
        approvalAmunt: "null",
        approvalDate: "null",
        approvalBy: "null",
        firstLevelAmount: "null",
        firstLevelDate: "null",
        firstVeryBy: "null",
        secondLevelAmount: "null",
        secondLevelDate: "null",
        secondVeryBy: "null",
        allocatedAmount: "null",
        allocatedMode: FundRqstvalues.paymntMode,
        allocatedVoucherNo: "null",
        allocatedVoucherType: "null",
        allocatedVocherCopy: "null",
        allocatedPrintedBy: "null",
        allocatedDate: "null",
        allocatedBy: "null",
        status: "1",
        remarks: FundRqstvalues.RequestRmks,
        requestStatus: FundRqstvalues.fundstatus,
        refundStatus: refundStatus,
      };
      FundRqst_service.insertPaymentDetails(details)
        .then((res) => {
          const message = res.data.message;
          if (message.toString() === "SUCCESS") {
            setMessage("Request Successfully");
            setseverit("success");
            setOpen(true);
            resetalloperation();
          } else {
            setMessage("Request Failed !!" + message.toString());
            setseverit("error");
            setOpen(true);
          }
          setreqstPros(false);
        })
        .catch((error) => {
          setMessage(error.message);
          setseverit("error");
          setOpen(true);
          setreqstPros(false);
        });
    }
  };
  const UpdatepaymentonClick = () => {
    if (Requestvalidate() === true) {
      setupdtPros(true);
      var ReqPaidto,
        refundStatus = "";
      if (FundRqstvalues.fundstatus === "JOB") {
        if (FundRqstvalues.paidto !== "") {
          ReqPaidto = FundRqstvalues.paidto;
        } else {
          ReqPaidto = null;
        }
      } else {
        if (FundRqstvalues.vendorType !== "") {
          ReqPaidto = FundRqstvalues.vendorType;
        } else {
          ReqPaidto = null;
        }
      }
      if (FundRqstvalues.fundrefundstatus !== "") {
        refundStatus = FundRqstvalues.fundrefundstatus;
      } else {
        refundStatus = null;
      }
      let details = {
        cmId: FundRqstvalues.purpose_pmtid,
        reqAmount: FundRqstvalues.RequestAmt,
        reqPurpose: FundRqstvalues.purposeOfpayment,
        reqPaidTo: ReqPaidto,
        reqDate: null,
        reqBy: getUserId(),
        approvalAmunt: null,
        approvalDate: null,
        approvalBy: null,
        firstLevelAmount: null,
        firstLevelDate: null,
        firstVeryBy: null,
        secondLevelAmount: null,
        secondLevelDate: null,
        secondVeryBy: null,
        allocatedAmount: null,
        allocatedMode: FundRqstvalues.paymntMode,
        allocatedVoucherNo: null,
        allocatedVoucherType: null,
        allocatedVocherCopy: null,
        allocatedPrintedBy: null,
        allocatedDate: null,
        allocatedBy: null,
        status: "1",
        remarks: FundRqstvalues.RequestRmks,
        referenceNo: null,
        bankName: null,
        accountNo: null,
        ifsc: null,
        benName: null,
        gstinPayee: null,
        requestStatus: FundRqstvalues.fundstatus,
        refundStatus: refundStatus,
      };
      FundRqst_service.updatePaymentDetails(details)
        .then((res) => {
          const message = res.data.message;
          if (message.toString() === "SUCCESS") {
            setMessage("Updated Successfully");
            setseverit("success");
            setOpen(true);
            resetalloperation();
          } else {
            setMessage("Updation Failed ..!!" + message.toString());
            setseverit("error");
            setOpen(true);
            document.getElementById("rqstamnt").focus();
          }
        })
        .catch((error) => {
          setMessage("Updation Failed " + error.message);
          setseverit("error");
          setOpen(true);
        });
    }
  };

  const nonRequestClick = () => {
    setnonRqstPros(true);
    let details = {
      cmId: FundRqstvalues.cmid,
      paymentId: FundRqstvalues.purpose_pmtid,
      status: "1",
      createdBy: getUserId(),
      requestStatus: FundRqstvalues.fundstatus,
    };
    FundRqst_service.updatePaymentStatus(details)
      .then((res) => {
        const message = res.data.message;
        if (message.toString() === "SUCCESS") {
          setMessage("Non-Requested Successfully");
          setseverit("success");
          setOpen(true);
          resetalloperation();
        } else {
          setMessage("Non Request Failed ..!!" + message.toString());
          setseverit("error");
          setOpen(true);
          document.getElementById("rqstamnt").focus();
          setnonRqstPros(false);
        }
      })
      .catch((error) => {
        setMessage("Non Request Failed " + error.message);
        setseverit("error");
        setOpen(true);
        setnonRqstPros(false);
      });
  };
  ///////
  const FinishBtnOnclick = () => {
    let details = {
      cmId: FundRqstvalues.cmid,
      status: "1",
      requestStatus: FundRqstvalues.fundstatus,
    };
    FundRqst_service.insertPaymentStatus(details)
      .then((res) => {
        const message = res.data.message;
        if (message.toString() === "SUCCESS") {
          setMessage("Inserted Successfully");
          setseverit("success");
          setOpen(true);
          resetalloperation();
        } else {
          setMessage("Insertion Failed Warning ..!!" + message.toString());
          setseverit("error");
          setOpen(true);
        }
      })
      .catch((error) => {
        setMessage("Insertion Failed " + error.message);
        setseverit("error");
        setOpen(true);
      });
  };
  ////
  const uploadrqstcopy = () => {
    setuplodaRqstCopyPros(true);
    if (
      FundRqstvalues.purposeOfpayment === "" ||
      !FundRqstvalues.purposeOfpayment
    ) {
      setMessage("Please Select Request Purpose............");
      setseverit("warning");
      setOpen(true);
      setimgUpload(false);
    } else {
      setimgUpload(true);
    }
    setuplodaRqstCopyPros(false);
  };
  const selectimgUpload = (event) => {
    var currentFile;
    const file = event.target.files[0];
    console.log("file " + JSON.stringify(file));
    const imageMimeTypepng = /image\/(png)/i;
    const imageMimeTypejpg = /image\/(jpg)/i;
    const imageMimeTypeJpeg = /image\/(jpeg)/i;
    const imageMimeTypePdf = /application\/(pdf)/i;
    const reader = new FileReader();
    reader.onload = () => {
      currentFile = reader.result;
      var recipetCopyFile = "";
      // console.log('currentFile '+JSON.stringify(currentFile))
      // console.log('file.type '+JSON.stringify(file.type))
      if (file.type.match(imageMimeTypepng)) {
        recipetCopyFile = currentFile.split("data:image/png;base64,");
      } else if (file.type.match(imageMimeTypejpg)) {
        recipetCopyFile = currentFile.split("data:image/jpeg;base64,");
      } else if (file.type.match(imageMimeTypeJpeg)) {
        recipetCopyFile = currentFile.split("data:image/jpeg;base64,");
      } else if (file.type.match(imageMimeTypePdf)) {
        recipetCopyFile = currentFile.split("data:application/pdf;base64,");
      }
      console.log("reader.readyState " + JSON.stringify(reader.readyState));
      if (reader.readyState === 2) {
        // let currentFile = b64toBlob(event.target.files,{type:'base64;charset=utf-8'})
        let details = {
          cmId: FundRqstvalues.cmid,
          reqPurpose: FundRqstvalues.purposeOfpayment,
          docImage: recipetCopyFile[1],
          createdBy: getUserId(),
          status: "1",
        };
        FundRqst_service.uploadPaymentCopy(details).then((res) => {
          const message = res.data.message;
          if (message.toString() === "SUCCESS") {
            setMessage("Inserted Successfully");
            setseverit("success");
            setOpen(true);
          } else {
            setMessage("Insertion Failed! " + message.toString());
            setseverit("warning");
            setOpen(true);
          }
          currentFile = "";
        });
        let details2 = {
          payments_id: FundRqstvalues.purpose_pmtid,
          ip_payment_receipt_copy: recipetCopyFile[1],
          user_id: getUserId(),
        };
        FundRqst_service.update_o_ac_payment_receipt_copy(details2).then(
          (res) => {
            const message = res.data.message;
            if (message.toString() === "SUCCESS") {
              setMessage("Inserted Successfully");
              setseverit("success");
              setOpen(true);
            } else {
              setMessage("Insertion Failed! " + message.toString());
              setseverit("warning");
              setOpen(true);
            }
            event.target.files[0] = null;
            reader.readyState = 2;
          }
        );
      }
    };
    reader.readAsDataURL(event.target.files[0]);
  };
  const saveimage = () => {
    setdwnldReqCopyPros(true);
    //  const documentimage= paymentcopydetails[0].docImage
    // console.log('in')
    // const lastresult = paymentcopydetails.map((item) => item);
    // console.log('before saveAs')
    let details = {
      cmId: FundRqstvalues.cmid,
      reqPurpose: FundRqstvalues.purpose_reqpurid,
      status: "1",
    };
    FundRqst_service.getPaymentCopy(details)
      .then((res) => {
        const data = res.data;
        const detaill = data.map((node) => node.docImage);
        console.log("detaill" + JSON.stringify(detaill));
        const filedata = detaill.toString();
        console.log("aftr string " + JSON.stringify(filedata));

        const formates = filedata.split("/9j/4");
        console.log("aftr split " + JSON.stringify(formates));
        if (formates[0] === "") {
          FileSaver.saveAs(
            `data:image/jpg;base64,${detaill.toString()}`,
            FundRqstvalues.cmid + "-" + FundRqstvalues.purposeOfpayment + ".jpg"
          );
        } else {
          const Pngformates = filedata.split("iVBORw0KGg");
          if (Pngformates[0] === "") {
            FileSaver.saveAs(
              `data:image/jpg;base64,${detaill.toString()}`,
              FundRqstvalues.cmid +
                "-" +
                FundRqstvalues.purposeOfpayment +
                ".jpg"
            );
          } else {
            FileSaver.saveAs(
              `data:application/pdf;base64,${detaill.toString()}`,
              FundRqstvalues.cmid +
                "-" +
                FundRqstvalues.purposeOfpayment +
                ".pdf"
            );
          }
        }
        setdwnldReqCopyPros(false);
      })
      .catch((error) => {
        setMessage("Insertion Failed! ," + error.message);
        setseverit("error");
        setOpen(true);
        setdwnldReqCopyPros(false);
      });

    // console.log('after saveAs')
  };
  /////
  const FundStatusDropdown = async () => {
    FundRqst_service.getFundStatus().then((res) => {
      setfundstatusdrp(res.data);
    });
  };
  ///
  const fundSrch = () => {
    return (
      <input
        style={{ width: "80px", textAlign: "center", fontSize: "12px" }}
        placeholder="Search"
        onChange={(e) => {
          fundOnchange(e.target.value);
        }}
      />
    );
  };
  const fundOnchange = (searchedVal) => {
    const filteredvalue = fundRqstdetails.filter((trns) => {
      return trns.consignmentNumber
        .toString()
        .toLowerCase()
        .includes(searchedVal.toLowerCase());
    });
    if (filteredvalue.length > 1) {
      setFilteredDetails(fundRqstdetails);
    } else {
      setFilteredDetails(filteredvalue);
    }
  };
  const fundSrch2 = () => {
    return (
      <input
        style={{ width: "80px", textAlign: "center", fontSize: "12px" }}
        placeholder="Search"
        onChange={(e) => {
          fund2Onchange(e.target.value);
        }}
      />
    );
  };
  const fund2Onchange = (searchedVal) => {
    const filteredvalue = fundRqstdetails4.filter((trns) => {
      return trns.consignmentNumber
        .toString()
        .toLowerCase()
        .includes(searchedVal.toLowerCase());
    });
    if (filteredvalue.length > 1) {
      setFilteredDetails2(fundRqstdetails4);
    } else {
      setFilteredDetails2(filteredvalue);
    }
  };
  useEffect(() => {
    FundStatusDropdown();
  }, []);

  const handleClose = () => {
    setOpen(false);
  };
  const navigate = useNavigate();
  const BackBotton = () => {
    navigate("/tracking");
  };
  const ForwordBotton = () => {
    navigate("/fundaprvl");
  };
  return (
    <div>
      <Snackbar
        open={open}
        message={message}
        severity={severit}
        onClose={handleClose}
      />
      <Home />
      <div
        style={{
          paddingLeft: "80px",
          transition: "1s",
          transitionDelay: "revert-layer",
        }}
      >
        <Row>
          <Col xs={1}>
            <ToggleButton
              onClick={BackBotton}
              className="headerstyleStrt"
              size="small"
            >
              <ArrowBackIosIcon
                fontSize="small"
                style={{
                  fontSize: "16px",
                  marginLeft: "5px",
                  color: "red",
                  fontWeight: "bold",
                }}
              />{" "}
            </ToggleButton>
          </Col>
          <Col xs={10}></Col>
          <Col xs={1} style={{ textAlign: "end" }}>
            {" "}
            <ToggleButton
              onClick={ForwordBotton}
              className="headerstyleEND"
              size="small"
            >
              <ArrowForwardIosIcon
                fontSize="small"
                style={{ fontSize: "16px", color: "red", fontWeight: "bold" }}
              />{" "}
            </ToggleButton>
          </Col>
        </Row>
        <Grid2 container>
          <Box style={{ width: "11.5%" }}>
            <Item1>
              {/* <ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small" >
                                <ArrowBackIosIcon fontSize='small' style={{ fontSize: '16px', marginLeft: '5px' }} /> </ToggleButton> */}
              <lable
                style={{
                  fontSize: "10px",
                  fontWeight: "bold",
                  color: "red",
                  marginLeft: "15px",
                  fontFamily: "Times New Roman",
                }}
              >
                NonRequest Job
              </lable>
              <TableContainer
                sx={{ maxHeight: 290 }}
                className="scrollbarPrime"
              >
                <Table stickyHeader className="table table-bordered">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell style={{ textAlign: "center" }}>
                        `{FundStsName()}
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell style={{ textAlign: "center" }}>
                        {fundSrch()}
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {FilteredDetails.map((trns) => {
                      const isItemSelected = isSelected(trns.consignmentNumber);
                      return (
                        <TableRow
                          hover
                          key={trns.consignmentNumber}
                          selected={isItemSelected}
                          onClick={() => getnonpurpose(trns)}
                        >
                          <StyledTableCell
                            style={{ textAlign: "center", color: "darkblue" }}
                          >
                            {trns.consignmentNumber}
                          </StyledTableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Item1>
          </Box>
          <Box style={{ width: "20%" }}>
            <Item>
              <lable
                style={{
                  fontSize: "10px",
                  fontWeight: "bold",
                  color: "red",
                  fontFamily: "Times New Roman",
                }}
              >
                NonRequest Purpose
              </lable>
              <TableContainer
                sx={{ maxHeight: 290 }}
                className="scrollbarPrime "
              >
                <Table stickyHeader className="table table-bordered">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell
                        style={{ width: "10px", textAlign: "center" }}
                      >
                        Sl
                      </StyledTableCell>
                      <StyledTableCell
                        style={{ textAlign: "center", width: "100px" }}
                      >
                        Description
                      </StyledTableCell>
                      <StyledTableCell
                        style={{ width: "40px", textAlign: "center" }}
                      >
                        Amount
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {fundRqstdetails2.map((trns) => (
                      <StyledTableRow
                        hover
                        key={trns.reqPurpose}
                        onClick={() => nonverifypurpose(trns)}
                      >
                        <StyledTableCell
                          style={{ color: "darkblue", textAlign: "center" }}
                        >
                          {trns.serialNumber}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ color: "darkblue", textAlign: "center" }}
                        >
                          {trns.reqPurpose}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ color: "darkblue", textAlign: "center" }}
                        >
                          {trns.reqAmount}
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Item>
          </Box>
          <Box style={{ width: "37%" }}>
            <Item>
              <div
                style={{
                  color: "red",
                  fontWeight: "bold",
                  fontSize: "20px",
                  marginTop: "2%",
                  marginBottom: "1.5%",
                  fontFamily: "Times New Roman",
                }}
              >
                <center>FUND REQUEST</center>
              </div>
              <Csscontrol
                fullWidth
                size="small"
                InputLabelProps={{ shrink: true }}
                style={{ width: "35%" }}
              >
                <InputLabel
                  id="demo-select-small"
                  style={{ fontFamily: "Times New Roman", fontWeight: "bold" }}
                >
                  Fund Status
                </InputLabel>
                <Select
                  label="Fund Statussssssss"
                  id="fundstatus"
                  style={{
                    fontSize: "13px",
                    fontFamily: "Times New Roman",
                    color: "black",
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                  onChange={FundRqstStatusHandleChange}
                  value={FundRqstvalues.fundstatus}
                >
                  <MenuItem></MenuItem>
                  {fundstatusdrp.map((status) => (
                    <MenuItem value={status.requestStatus}>
                      {status.requestStatus}
                    </MenuItem>
                  ))}
                </Select>
              </Csscontrol>
              {/* BE NO Input and Search Button */}
              <CssTextField
                hidden={BeNoHidden}
                size="small"
                sx={{
                  input: {
                    fontFamily: "Times New Roman",
                    color: "black",
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: "13px",
                  },
                }}
                label="BE No"
                variant="outlined"
                style={{ marginLeft: "2%", width: "35%" }}
                onChange={(e) => setBeNoValue(e.target.value)}
                value={beNoValue}
              />

              <Button
                size="small"
                hidden={BeNoSearchHidden}
                variant="contained"
                color="primary"
                style={{ marginLeft: "1%", fontFamily: "Times New Roman" }}
                onClick={handleBeNoSearch}
              >
                Search
              </Button>
              <CssTextField
                hidden={JobHidden}
                native
                size="small"
                sx={{
                  input: {
                    fontFamily: "Times New Roman",
                    color: "black",
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: "13px",
                  },
                }}
                label="Job No"
                variant="outlined"
                type={"number"}
                style={{ marginLeft: "2%", width: "35%" }}
                onChange={Request_jobNoHandleChange}
                value={FundRqstvalues.jobNo}
                onKeyDown={jobKeydown}
              />

              <Button
                size="small"
                hidden={searchbtnhidden}
                id="jobsearch"
                variant="contained"
                color="primary"
                style={{ marginLeft: "1%", fontFamily: "Times New Roman" }}
                onClick={Jobserachbtn}
              >
                {searchPros ? "processing..." : "Search"}
              </Button>

              <Csscontrol
                hidden={VendorHidden}
                fullWidth
                size="small"
                style={{ marginLeft: "2%", width: "35%" }}
              >
                <InputLabel
                  id="demo-select-small"
                  style={{ fontFamily: "Times New Roman", fontWeight: "bold" }}
                >
                  Vendor Type
                </InputLabel>
                <Select
                  label="Vendor Typeeee"
                  style={{
                    fontSize: "13px",
                    fontFamily: "Times New Roman",
                    color: "black",
                    fontWeight: "bold",
                    textAlign: "center",
                    backgroundColor: "white",
                  }}
                  id="vendor"
                  value={FundRqstvalues.vendorType}
                  native
                  onChange={Request_vendortypHandleChange}
                >
                  <option></option>
                  {vendordrp.map((trns) => (
                    <option value={trns.reqPaidTo}>{trns.reqPaidTo}</option>
                  ))}
                </Select>
              </Csscontrol>
              <div hidden={designHidden}>
                <div className="form-inline">
                  <CssTextField
                    size="small"
                    sx={{
                      input: {
                        fontFamily: "Times New Roman",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "center",
                        fontSize: "13px",
                      },
                    }}
                    id="rqstamnt"
                    style={{
                      marginTop: "5%",
                      width: "40%",
                      borderColor: "Red",
                    }}
                    label="Request Amount"
                    variant="outlined"
                    type={"number"}
                    onChange={Request_amtHandleChange}
                    value={FundRqstvalues.RequestAmt}
                    required
                    onKeyDown={RequestAMtKeydown}
                  />

                  <Csscontrol
                    size="small"
                    required
                    style={{ marginLeft: "2%", marginTop: "5%", width: "40%" }}
                    InputLabelProps={{ shrink: true }}
                  >
                    <InputLabel
                      style={{
                        fontFamily: "Times New Roman",
                        fontWeight: "bold",
                      }}
                    >
                      Purpose of payment
                    </InputLabel>
                    <Select
                      style={{
                        fontSize: "13px",
                        fontFamily: "Times New Roman",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "center",
                      }}
                      onKeyDown={purposeKeydown}
                      id="purposepaymnt"
                      label="Purpose of paymenttttt"
                      onChange={Request_purposeHandleChange}
                      native
                      value={FundRqstvalues.purposeOfpayment}
                    >
                      <option></option>
                      {purposePaymentdrp.map((trns) => (
                        <option value={trns.reqPurpose}>
                          {trns.reqPurpose}
                        </option>
                      ))}
                    </Select>
                  </Csscontrol>
                </div>
                <div className="form-inline">
                  <Csscontrol
                    hidden={paidtypehidden}
                    fullWidth
                    size="small"
                    required
                    style={{ marginTop: "1%", width: "40%" }}
                    InputLabelProps={{ shrink: true }}
                  >
                    <InputLabel
                      style={{
                        fontFamily: "Times New Roman",
                        fontWeight: "bold",
                      }}
                    >
                      paid Type
                    </InputLabel>
                    <Select
                      label="paid Typeeee"
                      style={{
                        fontSize: "13px",
                        fontFamily: "Times New Roman",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "center",
                      }}
                      id="paidtype"
                      onChange={Request_paidtypeHandleChange}
                      native
                      onKeyDown={paidtypeKeydown}
                      value={FundRqstvalues.paidtype}
                    >
                      <option></option>
                      {paidtypedrp.map((trns) => (
                        <option value={trns.reqPaidTo}>{trns.reqPaidTo}</option>
                      ))}
                    </Select>
                  </Csscontrol>

                  <Csscontrol
                    hidden={paidbyhidden}
                    fullWidth
                    size="small"
                    style={{ marginTop: "1%", marginLeft: "2%", width: "40%" }}
                    InputLabelProps={{ shrink: true }}
                  >
                    <InputLabel
                      id="demo-select-small"
                      style={{
                        fontFamily: "Times New Roman",
                        fontWeight: "bold",
                      }}
                    >
                      paid to
                    </InputLabel>
                    <Select
                      label="paid tooo"
                      id="paidto"
                      onKeyDown={paidtoKeydown}
                      style={{
                        fontSize: "13px",
                        fontFamily: "Times New Roman",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "center",
                      }}
                      native
                      onChange={Request_paidtoHandleChange}
                      value={FundRqstvalues.paidto}
                    >
                      <option></option>
                      {paidtodrp.map((trns) => (
                        <option value={trns.consignmentNumber}>
                          {trns.consignmentNumber}
                        </option>
                      ))}
                    </Select>
                  </Csscontrol>
                </div>
                <div className="form-inline">
                  <Csscontrol
                    fullWidth
                    size="small"
                    required
                    style={{ marginTop: "1%", width: "40%" }}
                  >
                    <InputLabel
                      id="demo-select-small"
                      style={{
                        fontFamily: "Times New Roman",
                        fontWeight: "bold",
                      }}
                    >
                      Payment Mode
                    </InputLabel>
                    <Select
                      label="Payment Modeeee"
                      onChange={Request_paymntmdHandleChange}
                      style={{
                        fontSize: "13px",
                        fontFamily: "Times New Roman",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "center",
                      }}
                      onKeyDown={paymentModeKeydown}
                      id="paymentmode"
                      native
                      value={FundRqstvalues.paymntMode}
                    >
                      <option></option>
                      {Paymentmode.map((trns) => (
                        <option value={trns.paymentType}>
                          {trns.paymentType}
                        </option>
                      ))}
                    </Select>
                  </Csscontrol>
                  <Csscontrol
                    fullWidth
                    size="small"
                    required
                    style={{ marginTop: "1%", marginLeft: "2%", width: "40%" }}
                  >
                    <InputLabel
                      id="demo-select-small"
                      style={{
                        fontFamily: "Times New Roman",
                        fontWeight: "bold",
                      }}
                    >
                      Fund Refund Status
                    </InputLabel>
                    <Select
                      label="Fund Refund Statusss"
                      id="fundrefund"
                      style={{
                        fontSize: "13px",
                        fontFamily: "Times New Roman",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "center",
                      }}
                      native
                      onKeyDown={refundStatusKeydown}
                      onChange={Request_fundrefundstatusHandleChange}
                      value={FundRqstvalues.fundrefundstatus}
                    >
                      <option value=""></option>
                      <option value="YES">YES</option>
                      <option value="NO">NO</option>
                    </Select>
                  </Csscontrol>
                </div>
                <CssTextField
                  size="small"
                  style={{ marginTop: "1%", width: "82%" }}
                  label="Request Remarks"
                  variant="outlined"
                  sx={{
                    input: {
                      fontFamily: "Times New Roman",
                      color: "black",
                      fontWeight: "bold",
                      textAlign: "center",
                      fontSize: "13px",
                    },
                  }}
                  onChange={Request_RmksHandleChange}
                  value={FundRqstvalues.RequestRmks}
                  id="remarksid"
                />
              </div>
            </Item>
          </Box>
          <Box style={{ width: "20%" }}>
            <Item>
              <lable
                style={{ fontSize: "10px", fontWeight: "bold", color: "red" }}
              >
                Request Purpose
              </lable>
              <TableContainer
                sx={{ maxHeight: 290 }}
                className="scrollbarPrime"
              >
                <Table stickyHeader className="table table-bordered">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell
                        style={{ width: "10px", textAlign: "center" }}
                      >
                        Sl
                      </StyledTableCell>
                      <StyledTableCell style={{ textAlign: "center" }}>
                        Description
                      </StyledTableCell>
                      <StyledTableCell
                        style={{ width: "40px", textAlign: "center" }}
                      >
                        Amount
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {fundRqstdetails3.map((trns) => {
                      const isItemSelected = isReqpurposeSelected(
                        trns.reqAmount
                      );
                      return (
                        <StyledTableRow
                          hover
                          selected={isItemSelected}
                          onClick={() => verifypurpose(trns)}
                          key={trns.reqPurpose}
                        >
                          <StyledTableCell
                            style={{ textAlign: "center", color: "darkblue" }}
                          >
                            {trns.serialNumber}
                          </StyledTableCell>
                          <StyledTableCell
                            style={{ textAlign: "center", color: "darkblue" }}
                          >
                            {trns.reqPurpose}
                          </StyledTableCell>
                          <StyledTableCell
                            style={{ textAlign: "center", color: "darkblue" }}
                          >
                            {trns.reqAmount}
                          </StyledTableCell>
                        </StyledTableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Item>
          </Box>
          <Box style={{ width: "11.5%" }}>
            <Item2>
              <lable
                style={{
                  fontSize: "10px",
                  fontWeight: "bold",
                  color: "red",
                  marginRight: "30px",
                }}
              >
                Request Job
              </lable>
              {/* <ToggleButton onClick={ForwordBotton} size="small" className='headerstyleEND'>
                                <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px' }} /> </ToggleButton> */}
              <TableContainer sx={{ maxHeight: 290 }}>
                <Table stickyHeader className="table table-bordered">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell style={{ textAlign: "center" }}>
                        `{FundStsName()}
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell style={{ textAlign: "center" }}>
                        {fundSrch2()}
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {FilteredDetails2.map((trns) => {
                      const isItemSelected = isReqjobSelected(
                        trns.consignmentNumber
                      );
                      return (
                        <StyledTableRow
                          hover
                          selected={isItemSelected}
                          key={trns.consignmentNumber}
                          onClick={() => getpurpose(trns)}
                        >
                          <StyledTableCell
                            style={{ textAlign: "center", color: "darkblue" }}
                          >
                            {trns.consignmentNumber}
                          </StyledTableCell>
                        </StyledTableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Item2>
          </Box>
        </Grid2>
        {/* ///hhh */}
        <center hidden={designHidden}>
          <div className="mt-2 mb-1 form-inline">
            <Button
              style={{ fontFamily: "Times New Roman" }}
              size="small"
              variant="contained"
              color="primary"
              className="mt-1"
              onClick={RequestonClick}
              disabled={rqstbtn}
            >
              {reqstPros ? "processing.." : "REQUEST"}
            </Button>{" "}
            <Button
              style={{ fontFamily: "Times New Roman" }}
              size="small"
              variant="contained"
              className="mt-1"
              color="primary"
              onClick={UpdatepaymentonClick}
              disabled={updatebtn}
            >
              {updtPros ? "processing.." : "UPDATE"}
            </Button>{" "}
            <Button
              style={{ fontFamily: "Times New Roman" }}
              size="small"
              variant="contained"
              className="mt-1"
              color="primary"
              disabled={nonReqbtn}
              onClick={nonRequestClick}
            >
              {nonRqstPros ? "processing.." : "NON REQUEST"}
            </Button>{" "}
            <Button
              style={{ fontFamily: "Times New Roman" }}
              size="small"
              variant="contained"
              className="mt-1"
              color="primary"
              onClick={RefreshBtn}
            >
              {RefreshPros ? "processing.." : "REFRESH"}
            </Button>{" "}
            <label
              style={{ fontFamily: "Times New Roman" }}
              onClick={uploadrqstcopy}
              hidden={uploadrqstcopybtn}
              className="btn btn-primary p-1 mt-1"
            >
              {uplodaRqstCopyPros ? "processing.." : "UPLOAD REQUEST COPY"}
              {imgUpload ? (
                <input
                  type="file"
                  accept=".jpeg,.jpg,.pdf,.png"
                  onChange={selectimgUpload}
                  hidden
                />
              ) : null}
            </label>{" "}
            <Button
              size="small"
              variant="contained"
              className="mt-1"
              color="primary"
              disabled={downloadrqstcopy}
              onClick={saveimage}
            >
              {dwnldReqCopyPros ? "processing.." : "DOWNLOAD REQUEST COPY"}
            </Button>{" "}
            <Button
              size="small"
              variant="contained"
              className="mt-1"
              color="primary"
              disabled={finish}
              onClick={FinishBtnOnclick}
            >
              {finishPros ? "processing.." : "FINISH"}
            </Button>
          </div>
        </center>
        <Item hidden={tablehidden}>
          <TableContainer sx={{ maxHeight: 215 }} className="scrollbarPrime">
            <Table stickyHeader className="table table-bordered">
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    Sl
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    Description
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    RequestAmount
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    Request_Date
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    RequestRemarks
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    RequestBy
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    ApprovalAmount
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    ApprovalDate
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    ApprovalRemarks
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    ApprovalBy
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    1stLevelAmount
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    1stLevelDate
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    1stLevelRemarks
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    1stApprovedBy
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    2ndLevelAmount
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    2ndLevelDate
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    2ndLevelRemarks
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    2nd_ApprovedBy
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    AllocatedAmount
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    AllocatedDate
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    AllocatedRemarks
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    AllocatedBY
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    ReleaseAmmount
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    ReleaseDate
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    ReleaseRemarks
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    Release_BY
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    AuditedAmmount
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    AuditedDate
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    AuditedRemarks
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    AuditedBY
                  </StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {fundRqstdetails5.map((trns) => (
                  <TableRow hover key={trns.reqPurpose}>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.serialNumber}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.reqPurpose}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.reqAmount}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.reqDate}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.reqRemarks}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.reqByName}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.approvalAmunt}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.approvalDate}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.appRemarks}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.approvalByName}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.firstLevelAmount}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.firstLevelDate}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.firstRemarks}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.firstLevelVeryBy}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.secondLevelAmount}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.secondLevelDate}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.secondRemarks}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.secondLevelVeryBy}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.allocatedAmount}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.allocatedDate}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.allocatedRemarks}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.allocatedByName}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.releaseAmount}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.release_date}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.releaseRemarks}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.releaseByName}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.audit_amount}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.audit_date}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.audit_remarks}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.audited_by}
                    </StyledTableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Item>
      </div>
    </div>
  );
}

export default FundRequest;
